import { render, staticRenderFns } from "./form-revision.vue?vue&type=template&id=44c1faf4"
import script from "./form-revision.vue?vue&type=script&lang=js"
export * from "./form-revision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports